// src/pages/ExperienceLetter.js
import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import html2pdf from 'html2pdf.js';
import '../letterstyles/ExperienceLetter.css';

const ExperienceLetter = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const printRef = useRef();
  const user = state?.user;

  const superAdminId = Number(localStorage.getItem('adminuserId')) || 0;

  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);

  const handlePrint = useReactToPrint({
      contentRef: printRef,
      documentTitle: 'Joining_Letter',
   });

 const handleDownloadPDF = () => {
  const element = printRef.current;

  const opt = {
    margin: [5, 5, 5, 5],          // Perfect padding so content doesn't cut
    filename: "Offer_Letter.pdf",
    image: { type: "jpeg", quality: 1 },

    html2canvas: {
      scale: 3,                   // HD rendering (fixes blurry text)
      useCORS: true,              // allows cross-origin images
      allowTaint: true,           // helps load local images
      logging: false,
      dpi: 300,
      letterRendering: true,
    },

    jsPDF: {
      unit: "mm",
      format: "a4",
      orientation: "portrait",
      compressPdf: true,
    },
  };

   html2pdf().set(opt).from(element).save();
  };

  // Fetch company details from API
  useEffect(() => {
    if (!user) {
      alert("No user data found!");
      navigate('/');
    }

    const fetchCompany = async () => {
      try {
        setLoading(true);
        const response = await fetch(
          `https://payyug.in/api/get-company?superAdminId=${superAdminId}`
        );
        const data = await response.json();

        if (response.ok && data) {
          // Construct logo URL dynamically
          if (data.logo) {
            data.logoUrl = `https://payyug.in/${data.logo.replace(/^images\//, '')}`;
          }
          setCompany(data);
        } else {
          console.error('Failed to fetch company data');
        }
      } catch (err) {
        console.error('Error fetching company details:', err);
      } finally {
        setLoading(false);
      }
    };

    if (superAdminId) fetchCompany();
  }, [navigate, user, superAdminId]);

  if (!user) return null;
  if (loading) return <p>Loading company details...</p>;

  return (
    <div className="experience-wrapper">
      <div className="experience-letter" ref={printRef}>
       <div className="letter-header">
          <img 
            src={company?.logoUrl || '/default-logo.png'} 
            alt="Company Logo" 
            className="letter-logo" 
          />
          <div className="letter-company-info"  style={{ textAlign: 'center' }}>
            <h2>{company?.name}</h2>
            <p><strong>CIN:</strong> {company?.cin}</p>
            <p><strong>Regt. Office:</strong> {company?.address}</p>
            <p><strong>Email:</strong> {company?.email}</p>
            <p><strong>Contact:</strong> {company?.contact || 'N/A'}</p>
          </div>
          <img
            style={{ opacity: 0 }}
            src={company?.logoUrl || "/default-logo.png"}
            alt="Company Logo"
            className="letter-logo"
          />

        </div>
        {/* Experience Letter */}
          <div
            style={{
              textAlign: "center",
              margin: "20px 0",
            }}
          >
            <h2
              style={{
                margin: 0,
                fontWeight: "600",
                fontSize: "20px",
                letterSpacing: "1px",
                textTransform: "uppercase",
              }}
            >
              Experience Letter
            </h2>
          </div>

        <div className="letter-body">
          <p style={{ textAlign: 'right' }}><strong>Date:</strong> {new Date().toLocaleDateString()}</p>
          <p><strong>To,</strong></p>
          <p>{user.fullName}</p>
          <p>{user.branch}</p>

          <p><strong>Subject:</strong> Experience Certificate</p>

          <p>Dear {user.fullName},</p>

          <p>
            This is to certify that <strong>{user.fullName}</strong> was employed with <strong>{company?.name}</strong> as a <strong>{user.role}</strong>
            at our <strong>{user.branch}</strong> branch from <strong>01-Jan-2021</strong> to <strong>30-Jun-2025</strong>.
          </p>

          <p>
            During the tenure, {user.name} exhibited excellent performance, professionalism, and dedication to responsibilities.
            We appreciate the contributions and wish the best in future endeavors.
          </p>

          <p>We wish {user.name} all the success in future.</p>

          <p>Regards,</p>
          <br />
          <p><strong>HR Manager</strong><br /><br />{company?.name}</p>
        </div>

        <div className="letter-footer">
          <hr />
          <p>{company?.name} | CIN: {company?.cin}</p>
          <p>{company?.email} | {company?.contact}</p>
        </div>
      </div>

       <div className="letter-actions">
        <button className="letter-action-button" onClick={handlePrint}>🖨️ Print</button>
        <button className="letter-action-button" onClick={handleDownloadPDF}>⬇️ Download</button>
      </div>


    </div>
  );
};

export default ExperienceLetter;